import { User } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface UserProfileProps {
  name: string;
  company: string;
  avatarUrl?: string;
}

export const UserProfile = ({ name, company, avatarUrl }: UserProfileProps) => {
  return (
    <div className="p-4 border-b">
      <div className="flex items-center space-x-3">
        <Avatar>
          <AvatarImage src={avatarUrl} />
          <AvatarFallback>
            <User className="w-4 h-4" />
          </AvatarFallback>
        </Avatar>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {name}
          </p>
          <p className="text-xs text-gray-500 truncate">
            {company}
          </p>
        </div>
      </div>
    </div>
  );
};